import React, { useState } from 'react'
import Joyride, { ACTIONS } from 'react-joyride'
import TourHeaderComponent from './TourHeaderComponent'
import TourBottomComponent from './TourBottomComponent'
import { FormattedMessage, useIntl } from 'react-intl'

const TOUR_CM_AI = 'TOUR_CM_AI'
const TOUR_CREDIT_USAGE = 'TOUR_CREDIT_USAGE'
const TOUR_PRE_GENERATED_TOPICS = 'TOUR_PRE_GENERATED_TOPICS'
const TOUR_WRITE_YOUR_OWN_PROMPT = 'TOUR_WRITE_YOUR_OWN_PROMPT'
const TOUR_IMPROVE_AND_RINE = 'TOUR_IMPROVE_AND_RINE'
const TOUR_CREDIT_WILL_NOT_BE_REFUNDED = 'TOUR_CREDIT_WILL_NOT_BE_REFUNDED'

const FirstStep = (props) => {
  const { onClickNext, onClickSkip } = props
  const { formatMessage } = useIntl()
  return (
    <div className="flex flex-col">
      <TourHeaderComponent
        text={formatMessage({
          id: 'tour.firstScenario.firstStep.title',
        })}
      ></TourHeaderComponent>
      <div className="flex flex-col p-5">
        <p className="text-16 text-gray-700 text-left">
          <FormattedMessage
            id={'tour.firstScenario.firstStep.firstParagraph'}
          />
        </p>
        <p className="text-16 text-gray-700 text-left py-5">
          <FormattedMessage
            id={'tour.firstScenario.firstStep.secondParagraph'}
          />
        </p>
      </div>
      <TourBottomComponent
        onClickNext={onClickNext}
        onClickSkip={onClickSkip}
        numberOfDot={6}
        activeIndex={0}
      ></TourBottomComponent>
    </div>
  )
}

const SecondStep = (props) => {
  const { onClickPrevious, onClickNext, onClickSkip } = props
  const { formatMessage } = useIntl()
  return (
    <div className="flex flex-col">
      <TourHeaderComponent
        text={formatMessage({
          id: 'tour.firstScenario.secondStep.title',
        })}
      ></TourHeaderComponent>
      <div className="overflow-y-auto" style={{ height: '300px' }}>
        <div className="flex flex-col p-5 space-y-5">
          <p className="text-16 text-gray-700 mb-4 text-left">
            <FormattedMessage
              id={'tour.firstScenario.secondStep.firstParagraph'}
            />
          </p>
          <h3 className="font-bold text-gray-900 my-5 text-left">
            <FormattedMessage
              id={'tour.firstScenario.secondStep.precautions.title'}
            />
          </h3>
          <p className="text-16 text-gray-700 mb-4 text-left">
            <strong className="pr-4">
              <FormattedMessage
                id={'tour.firstScenario.secondStep.languageCompatibility.title'}
              />
            </strong>
            <FormattedMessage
              id={'tour.firstScenario.secondStep.languageCompatibility.body'}
            />
          </p>
          <p className="text-16 text-gray-700 mb-4 text-left">
            <strong className="pr-4">
              <FormattedMessage
                id={'tour.firstScenario.secondStep.contentLimitations.title'}
              />
            </strong>

            <FormattedMessage
              id={'tour.firstScenario.secondStep.contentLimitations.body'}
            />
          </p>
          <p className="text-16 text-gray-700 mb-4 text-left">
            <strong className="pr-4">
              <FormattedMessage
                id={'tour.firstScenario.secondStep.betaPhase.title'}
              />
            </strong>
            <FormattedMessage
              id={'tour.firstScenario.secondStep.betaPhase.body'}
            />
          </p>
          <p className="text-16 text-gray-700 mb-4 text-left">
            <strong className="pr-4">
              <FormattedMessage
                id={'tour.firstScenario.secondStep.reviewAndEdit.title'}
              />
            </strong>
            <FormattedMessage
              id={'tour.firstScenario.secondStep.reviewAndEdit.body'}
            />
          </p>

          <h3 className="font-bold text-gray-900  my-5 text-left">
            <FormattedMessage
              id={'tour.firstScenario.secondStep.legalNotice.title'}
            />
          </h3>
          <p className="text-16 text-gray-700 mb-4 text-left">
            <FormattedMessage
              id={'tour.firstScenario.secondStep.legalNotice.body'}
            />
          </p>
        </div>
      </div>
      <TourBottomComponent
        onClickPrevious={onClickPrevious}
        onClickNext={onClickNext}
        onClickSkip={onClickSkip}
        numberOfDot={6}
        activeIndex={1}
      ></TourBottomComponent>
    </div>
  )
}

const CreditUsageStep = (props) => {
  const { onClickNext, onClickSkip, onClickPrevious } = props
  const { formatMessage } = useIntl()
  return (
    <div className="flex flex-col">
      <TourHeaderComponent
        text={formatMessage({
          id: 'tour.creditsUsage.title',
        })}
      ></TourHeaderComponent>
      <div className="p-5 bg-white">
        <div className="text-gray-800 mb-4 text-left">
          <FormattedMessage id={'tour.creditsUsage.firstParagraph'} />
        </div>
        <div className="font-bold text-gray-800 text-left mt-5">
          <FormattedMessage id={'tour.creditsUsage.note.label'} />
        </div>
        <div className="text-gray-800 text-left">
          <FormattedMessage id={'tour.creditsUsage.note.body'} />
        </div>
      </div>
      <TourBottomComponent
        onClickNext={onClickNext}
        onClickSkip={onClickSkip}
        onClickPrevious={onClickPrevious}
        numberOfDot={6}
        activeIndex={2}
      ></TourBottomComponent>
    </div>
  )
}

const PregenerateTopicStep = (props) => {
  const { onClickNext, onClickSkip, onClickPrevious } = props
  const { formatMessage } = useIntl()
  return (
    <div className="flex flex-col">
      <TourHeaderComponent
        text={formatMessage({ id: 'tour.pregenerateTopic.title' })}
      ></TourHeaderComponent>
      <div className="p-5 bg-white">
        <p className="text-gray-800 mb-4 text-left">
          <FormattedMessage id={'tour.pregenerateTopic.firstParagraph'} />
        </p>
      </div>
      <TourBottomComponent
        onClickPrevious={onClickPrevious}
        onClickNext={onClickNext}
        onClickSkip={onClickSkip}
        numberOfDot={6}
        activeIndex={3}
      ></TourBottomComponent>
    </div>
  )
}

const WriteYourOwnPrompt = (props) => {
  const { onClickNext, onClickSkip, onClickPrevious } = props
  const { formatMessage } = useIntl()
  return (
    <div className="flex flex-col">
      <TourHeaderComponent
        text={formatMessage({ id: 'tour.writePrompt.title' })}
      ></TourHeaderComponent>
      <div className="p-5 bg-white">
        <p className="text-gray-800 mb-4 text-left">
          <FormattedMessage id={'tour.writePrompt.firstParagraph'} />
        </p>
        <p className="text-gray-800 text-left mt-5">
          <strong className="pr-4">
            <FormattedMessage id={'tour.writePrompt.bullet.label'} />
          </strong>
          <FormattedMessage id={'tour.writePrompt.secondParagraph'} />
        </p>
      </div>

      <TourBottomComponent
        onClickPrevious={onClickPrevious}
        onClickNext={onClickNext}
        onClickSkip={onClickSkip}
        numberOfDot={6}
        activeIndex={4}
      ></TourBottomComponent>
    </div>
  )
}

const ImproveAndRefineStep = (props) => {
  const { onClickPrevious, onClickFinish } = props
  const { formatMessage } = useIntl()
  return (
    <div className="flex flex-col">
      <TourHeaderComponent
        text={formatMessage({ id: 'tour.improve.title' })}
      ></TourHeaderComponent>
      <div className="p-5 bg-white space-y-5">
        <p className="text-gray-800 text-left">
          <FormattedMessage id={'tour.improve.firstParagraph'} />
        </p>
        <p className="text-gray-800  text-left">
          <span className="font-bold pr-4">
            <FormattedMessage id={'tour.improve.adjust.label'} />
          </span>
          <FormattedMessage id={'tour.improve.adjust.body'} />
        </p>
        <p className="text-gray-800 text-left">
          <span className="font-bold pr-4">
            <FormattedMessage id={'tour.improve.message.label'} />
          </span>
          <FormattedMessage id={'tour.improve.message.body'} />
        </p>
      </div>
      <TourBottomComponent
        onClickPrevious={onClickPrevious}
        onClickFinish={onClickFinish}
        numberOfDot={6}
        activeIndex={5}
      ></TourBottomComponent>
    </div>
  )
}

const CMAITour = (props) => {
  const {
    run,
    onClickSkip,
    openGeneratingTextWithAIScreen,
    openRefineContentScreen,
    onClickFinish,
    closeGeneratingTextWithAIScreen,
  } = props
  const [stepIndex, setStepIndex] = useState(0)

  const handleCallback = (data) => {
    const { action } = data
    if (action === ACTIONS.CLOSE) {
      onClickSkip()
      setStepIndex(0)
    }
  }
  const handleOnClickSkip = () => {
    setStepIndex(0)
    onClickSkip()
  }

  const handleOnClickFinish = () => {
    setStepIndex(0)
    onClickFinish()
  }

  const aiComposeSteps = [
    {
      target: `.${TOUR_CM_AI}`,
      content: (
        <FirstStep
          onClickNext={() => setStepIndex(1)}
          onClickSkip={handleOnClickSkip}
        ></FirstStep>
      ),
      placement: 'left',
      disableBeacon: true,
      hideFooter: true,
      styles: {
        options: {
          width: 500,
        },
      },
    },
    {
      target: `.${TOUR_CM_AI}`,
      content: (
        <SecondStep
          onClickNext={() => {
            //force delay to wait til compose finish rerender because it show another dialog
            openGeneratingTextWithAIScreen()
            setTimeout(() => {
              setStepIndex(2)
            }, 200)
          }}
          onClickPrevious={() => setStepIndex(0)}
          onClickSkip={handleOnClickSkip}
        ></SecondStep>
      ),
      placement: 'left',
      disableBeacon: true,
      hideFooter: true,
      styles: {
        options: {
          width: 500,
        },
      },
    },
    {
      target: `.${TOUR_CREDIT_USAGE}`,
      content: (
        <CreditUsageStep
          onClickNext={() => {
            setStepIndex(3)
          }}
          onClickPrevious={() => {
            closeGeneratingTextWithAIScreen()
            setStepIndex(1)
          }}
          onClickSkip={handleOnClickSkip}
        ></CreditUsageStep>
      ),
      placement: 'left',
      disableBeacon: true,
      hideFooter: true,
      styles: {
        options: {
          width: 500,
        },
      },
    },
    {
      target: `.${TOUR_PRE_GENERATED_TOPICS}`,
      content: (
        <PregenerateTopicStep
          onClickNext={() => setStepIndex(4)}
          onClickPrevious={() => setStepIndex(2)}
          onClickSkip={handleOnClickSkip}
        ></PregenerateTopicStep>
      ),
      placement: 'top',
      disableBeacon: true,
      hideFooter: true,
      styles: {
        options: {
          width: 500,
        },
      },
    },
    {
      target: `.${TOUR_WRITE_YOUR_OWN_PROMPT}`,
      content: (
        <WriteYourOwnPrompt
          onClickNext={() => {
            openRefineContentScreen()
            setStepIndex(5)
          }}
          onClickPrevious={() => setStepIndex(3)}
          onClickSkip={handleOnClickSkip}
        ></WriteYourOwnPrompt>
      ),
      placement: 'right',
      disableBeacon: true,
      hideFooter: true,
      styles: {
        options: {
          width: 500,
        },
      },
    },
    {
      target: `.${TOUR_IMPROVE_AND_RINE}`,
      content: (
        <ImproveAndRefineStep
          onClickFinish={handleOnClickFinish}
          onClickPrevious={() => {
            openGeneratingTextWithAIScreen()
            setStepIndex(4)
          }}
          onClickSkip={handleOnClickSkip}
        ></ImproveAndRefineStep>
      ),
      placement: 'bottom',
      disableBeacon: true,
      hideFooter: true,
      styles: {
        options: {
          width: 500,
        },
      },
    },
  ]

  return (
    <Joyride
      stepIndex={stepIndex}
      steps={aiComposeSteps}
      run={run}
      disableOverlayClose={true}
      spotlightClicks={false}
      styles={{
        options: {
          arrowColor: '#fff',
          backgroundColor: '#fff',
          zIndex: 9999,
          padding: '10px !important',
        },
        tooltip: {
          padding: '10px !important',
        },
      }}
      hideBackButton={true}
      hideCloseButton={true}
      callback={handleCallback}
    />
  )
}

export default React.memo(CMAITour)
export {
  TOUR_CM_AI,
  TOUR_CREDIT_USAGE,
  TOUR_PRE_GENERATED_TOPICS,
  TOUR_WRITE_YOUR_OWN_PROMPT,
  TOUR_IMPROVE_AND_RINE,
  TOUR_CREDIT_WILL_NOT_BE_REFUNDED,
}
